import React, { useEffect, useState } from 'react';

import { filterMethod } from '../../Helpers/helpers';

import { Grid, Typography, TextField, Autocomplete } from '@mui/material';

function JobCardGas(props) {
  const gasList = props.gasList;
  const gasValues = props.gasValues;
  const setGasType = props.setGasType;
  const setGasIn = props.setGasIn;
  const setGasOut = props.setGasOut;
  // const setCalcGasUsed = props.setCalcGasUsed;

  const [gasTypeValue, setGasTypeValue] = useState(
    gasValues.gas_type || { id: '4040404040', name: 'loading' }
  );
  const [gasInValue, setGasInValue] = useState(
    parseFloat(gasValues.gas_in).toFixed(2)
  );
  const [gasOutValue, setGasOutValue] = useState(gasValues.gas_out);
  const [maxGasOutValue, setMaxGasOutValue] = useState(gasValues.gas_in);
  const [gasUsed, setGasUsed] = useState('');

  useEffect(() => {
    const data = gasValues;
    setGasTypeValue(
      data.gas_type === undefined
        ? { id: '404040404', name: 'not used' }
        : data.gas_type
    );
    setGasInValue(data.gas_in === undefined ? '0' : data.gas_in);
    setGasOutValue(data.gas_out === undefined ? '0' : data.gas_out);
  }, [gasValues]);

  const [gasNegative, setGasNegative] = useState(false);

  useEffect(() => {
    const gasIn = gasInValue;
    const gasOut = gasOutValue;
    const gasUsed = parseFloat(gasIn) - parseFloat(gasOut);
    gasUsed.toFixed(2);
    if (gasUsed < 0) {
      setGasNegative(true);
    }
    setGasUsed(gasUsed.toFixed(2));
  }, [gasInValue, gasOutValue]);

  const [gasOptions, setGasOptions] = useState([]);

  useEffect(() => {
    const gasOptions = gasList;
    let newList;
    newList = gasOptions.map((obj) => ({
      name: obj.code,
      id: obj.id,
    }));
    setGasOptions(newList);
  }, [gasList]);

  const handleGasType = (event, newValue) => {
    setGasType(newValue);
  };

  const handleGas = (event) => {
    switch (event.target.id) {
      case 'gas_in':
        if (event.target.value < 0) {
          setGasIn(0);
          setMaxGasOutValue(0);
        } else {
          setGasIn(event.target.value);
          setMaxGasOutValue(event.target.value);
        }

        break;
      case 'gas_out':
        if (event.target.value < 0) {
          setGasOut(0);
        }
        // else
        // if (event.target.value > gasInValue) {
        //   setGasOut(gasInValue);
        // }
        else {
          setGasOut(event.target.value);
        }
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={3}
        md={1.5}
        style={{
          textAlign: 'left',
          borderRight: 'none',
          paddingLeft: '15px',
        }}
        sx={{
          '@media print': { width: '12.5%' },
          width: '50%',
        }}
      >
        <Typography fontWeight='700' variant='subtitle1'>
          Gas Type:
        </Typography>
      </Grid>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={3}
        md={1.5}
        style={{
          textAlign: 'left',
          borderLeft: 'none',
        }}
        sx={{
          '@media print': { width: '12.5%' },
          width: '50%',
        }}
      >
        {/* <TextField size='small' fullWidth /> */}
        <Autocomplete
          sx={{
            width: '100%',
            background: '#ffffff',
            padding: 0,
          }}
          name='gasType'
          key='gasType'
          id='gasType'
          variant='standard'
          size='small'
          value={gasTypeValue}
          onChange={handleGasType}
          disablePortal
          options={gasOptions}
          filterOptions={filterMethod}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField className='input-print-style' {...params} />
          )}
          // isOptionEqualToValue={(option, value) => {
          //   return option.name === value.name ? true : false;
          // }}
        />
        {/* {console.log('VAL', gasValues.gas_type)} */}
      </Grid>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={3}
        md={1.5}
        style={{
          textAlign: 'left',
          borderRight: 'none',
          paddingLeft: '15px',
        }}
        sx={{
          '@media print': { width: '12.5%' },
          width: '50%',
        }}
      >
        <Typography fontWeight='700' variant='subtitle1'>
          Gas In(kg):
        </Typography>
      </Grid>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={3}
        md={1.5}
        style={{
          textAlign: 'left',
          borderLeft: 'none',
        }}
        sx={{
          '@media print': { width: '12.5%' },
          width: '50%',
        }}
      >
        <TextField
          className='input-print-style'
          id='gas_in'
          type='number'
          inputProps={{
            step: 0.01,
            min: 0,
            max: 100,
          }}
          value={gasInValue}
          size='small'
          fullWidth
          onChange={handleGas}
        />
      </Grid>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={3}
        md={1.5}
        style={{
          textAlign: 'left',
          borderRight: 'none',
          paddingLeft: '15px',
          // borderBottom:
          //   title === 'Store Order Number/s:' || title === 'GRN Number:'
          //     ? 'grey solid 1px'
          //     : 'none',
        }}
        sx={{
          '@media print': { width: '12.5%' },
          width: '50%',
        }}
      >
        <Typography fontWeight='700' variant='subtitle1'>
          Gas Out(kg):
        </Typography>
      </Grid>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={3}
        md={1.5}
        style={{
          textAlign: 'left',
          borderLeft: 'none',
        }}
        sx={{
          '@media print': { width: '12.5%' },
          width: '50%',
        }}
      >
        <TextField
          className='input-print-style'
          id='gas_out'
          type='number'
          inputProps={{
            step: 0.01,
            min: 0,
            max: maxGasOutValue,
          }}
          value={gasOutValue}
          size='small'
          fullWidth
          onChange={handleGas}
        />
      </Grid>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={3}
        md={1.5}
        style={{
          textAlign: 'left',
          borderRight: 'none',
          paddingLeft: '15px',
        }}
        sx={{
          '@media print': { width: '12.5%' },
          width: '50%',
        }}
      >
        <Typography fontWeight='700' variant='subtitle1'>
          Total Used:
        </Typography>
      </Grid>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={3}
        md={1.5}
        style={{
          textAlign: 'left',
          borderLeft: 'none',
        }}
        sx={{
          '@media print': { width: '12.5%' },
          width: '50%',
        }}
      >
        <TextField
          className='input-print-style'
          size='small'
          fullWidth
          value={isNaN(gasUsed) ? '0' : gasUsed}
        />
      </Grid>
    </>
  );
}

export default JobCardGas;
